import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../../../layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_plugin_b087806a from 'nuxt_plugin_plugin_b087806a' // Source: ./components/plugin.js (mode: 'all')
import nuxt_plugin_plugin_22fddffa from 'nuxt_plugin_plugin_22fddffa' // Source: ./vuetify/plugin.js (mode: 'all')
import nuxt_plugin_workbox_6086b786 from 'nuxt_plugin_workbox_6086b786' // Source: ./workbox.js (mode: 'client')
import nuxt_plugin_metaplugin_40805e50 from 'nuxt_plugin_metaplugin_40805e50' // Source: ./pwa/meta.plugin.js (mode: 'all')
import nuxt_plugin_iconplugin_452803c4 from 'nuxt_plugin_iconplugin_452803c4' // Source: ./pwa/icon.plugin.js (mode: 'all')
import nuxt_plugin_axios_3fbf8361 from 'nuxt_plugin_axios_3fbf8361' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_recaptcha_56e97950 from 'nuxt_plugin_recaptcha_56e97950' // Source: ./recaptcha.js (mode: 'all')
import nuxt_plugin_filters_98405076 from 'nuxt_plugin_filters_98405076' // Source: ../../../plugins/filters (mode: 'all')
import nuxt_plugin_vuecomponent_89606480 from 'nuxt_plugin_vuecomponent_89606480' // Source: ../../../plugins/vue-component (mode: 'all')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root ? this.$root.$options.$nuxt : null
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":true,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const store = createStore(ssrContext)
  const router = await createRouter(ssrContext, config, { store })

  // Add this.$router into store actions/mutations
  store.$router = router

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"title":"Certificado Digital em Curitiba | Senha Digital Soluções Digitais","htmlAttrs":{"lang":"pt-BR"},"meta":[{"name":"viewport","content":"width=device-width, initial-scale=1, maximum-scale=3"},{"charset":"utf-8"},{"name":"format-detection","content":"telephone=no"},{"http-equiv":"X-UA-Compatible","content":"IE=edge,chrome=1","hid":"ie-compatibility"},{"hid":"description","name":"description","content":"Emita seu Certificado Digital em Curitiba com quem tem mais de 5 mil avaliações positivas. Atendimento rápido, seguro e 100 % autorizado pelo ITI."},{"hid":"keywords","name":"keywords","content":"certificado digital Curitiba, certificado e-CPF, e-CNPJ, assinatura digital, emissão de certificado digital PR"},{"name":"author","content":"Senha Digital Soluções Digitais"},{"name":"robots","content":"index, follow, max-image-preview:large"},{"name":"geo.region","content":"BR-PR"},{"name":"geo.placename","content":"Curitiba, Paraná"},{"name":"geo.position","content":"-25.4284;-49.2733"},{"name":"ICBM","content":"-25.4327, -49.2673"},{"name":"theme-color","content":"#045C90"},{"name":"referrer","content":"no-referrer-when-downgrade"},{"hid":"og:type","property":"og:type","content":"website"},{"hid":"og:title","property":"og:title","content":"Certificado Digital em Curitiba | Senha Digital"},{"hid":"og:url","property":"og:url","content":"https:\u002F\u002Fsenhadigital.com.br\u002F"},{"hid":"og:description","property":"og:description","content":"Certificados digitais para pessoas e empresas, emissão em poucos minutos no Centro de Curitiba."},{"property":"og:image","content":"https:\u002F\u002Fsenhadigital.com.br\u002Fimage-bank\u002Fog-image.jpg"},{"property":"og:image:width","content":"1200"},{"property":"og:image:height","content":"630"},{"property":"og:site_name","content":"Senha Digital"},{"hid":"twitter:card","name":"twitter:card","content":"summary_large_image"},{"hid":"twitter:title","name":"twitter:title","content":"Certificado Digital em Curitiba | Senha Digital"},{"hid":"twitter:description","name":"twitter:description","content":"Mais de 5 mil avaliações no Google. Emita seu certificado digital com agilidade e segurança."},{"hid":"twitter:image","name":"twitter:image","content":"https:\u002F\u002Fsenhadigital.com.br\u002Fimage-bank\u002Fog-image.jpg"}],"script":[{"hid":"ld-business","type":"application\u002Fld+json","json":{"@context":"https:\u002F\u002Fschema.org","@type":"LocalBusiness","name":"Senha Digital Soluções Digitais","image":"https:\u002F\u002Fsenhadigital.com.br\u002Fimage-bank\u002Fog-image.jpg","url":"https:\u002F\u002Fsenhadigital.com.br","telephone":"+55-41-3027-2710","priceRange":"$$","address":{"@type":"PostalAddress","streetAddress":"Av. Visconde de Guarapuava, 2764 - sala 405 - Centro","addressLocality":"Curitiba","addressRegion":"PR","postalCode":"80010-100","addressCountry":"BR"},"geo":{"@type":"GeoCoordinates","latitude":-25.4327,"longitude":-49.2673},"openingHoursSpecification":[{"@type":"OpeningHoursSpecification","dayOfWeek":["Monday","Tuesday","Wednesday","Thursday"],"opens":"08:00","closes":"17:50"},{"@type":"OpeningHoursSpecification","dayOfWeek":"Friday","opens":"08:00","closes":"17:40"}],"aggregateRating":{"@type":"AggregateRating","ratingValue":"5.0","reviewCount":"2809"},"sameAs":["https:\u002F\u002Fwww.facebook.com\u002Fsenhadigital","https:\u002F\u002Fwww.instagram.com\u002Fsenhadigital"]}},{"hid":"ld-faq","type":"application\u002Fld+json","json":{"@context":"https:\u002F\u002Fschema.org","@type":"FAQPage","mainEntity":[{"@type":"Question","name":"Quanto tempo leva para emitir meu certificado digital?","acceptedAnswer":{"@type":"Answer","text":"Na Senha Digital a emissão leva em média 15 minutos após a validação presencial ou por videoconferência."}},{"@type":"Question","name":"Quais documentos preciso levar?","acceptedAnswer":{"@type":"Answer","text":"Para pessoa física: RG, CPF e comprovante de endereço. Para pessoa jurídica: contrato social, documentos dos sócios e comprovante de endereço da empresa."}},{"@type":"Question","name":"O certificado digital da Senha Digital é reconhecido pelo ITI?","acceptedAnswer":{"@type":"Answer","text":"Sim. Somos Autoridade de Registro credenciada pelo Instituto Nacional de Tecnologia da Informação (ITI), garantindo validade jurídica em todo o território nacional."}}]}},{"src":"https:\u002F\u002Fwww.googletagmanager.com\u002Fgtag\u002Fjs?id=G-QCP89CMGBX","async":true},{"hid":"gtag-init","innerHTML":"\n          window.dataLayer = window.dataLayer || [];\n          function gtag(){dataLayer.push(arguments);}\n          gtag('js', new Date());\n          gtag('config', 'G-QCP89CMGBX');\n        ","type":"text\u002Fjavascript","charset":"utf-8"}],"__dangerouslyDisableSanitizersByTagID":{"gtag-init":["innerHTML"]},"link":[{"rel":"stylesheet","type":"text\u002Fcss","href":"https:\u002F\u002Ffonts.googleapis.com\u002Fcss?family=Roboto:100,300,400,500,700,900&display=swap"},{"rel":"stylesheet","type":"text\u002Fcss","href":"https:\u002F\u002Fcdn.jsdelivr.net\u002Fnpm\u002F@mdi\u002Ffont@latest\u002Fcss\u002Fmaterialdesignicons.min.css"}],"style":[]},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    beforeSerializeFns: ssrContext ? ssrContext.beforeSerializeFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_plugin_b087806a === 'function') {
    await nuxt_plugin_plugin_b087806a(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin_22fddffa === 'function') {
    await nuxt_plugin_plugin_22fddffa(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_workbox_6086b786 === 'function') {
    await nuxt_plugin_workbox_6086b786(app.context, inject)
  }

  if (typeof nuxt_plugin_metaplugin_40805e50 === 'function') {
    await nuxt_plugin_metaplugin_40805e50(app.context, inject)
  }

  if (typeof nuxt_plugin_iconplugin_452803c4 === 'function') {
    await nuxt_plugin_iconplugin_452803c4(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_3fbf8361 === 'function') {
    await nuxt_plugin_axios_3fbf8361(app.context, inject)
  }

  if (typeof nuxt_plugin_recaptcha_56e97950 === 'function') {
    await nuxt_plugin_recaptcha_56e97950(app.context, inject)
  }

  if (typeof nuxt_plugin_filters_98405076 === 'function') {
    await nuxt_plugin_filters_98405076(app.context, inject)
  }

  if (typeof nuxt_plugin_vuecomponent_89606480 === 'function') {
    await nuxt_plugin_vuecomponent_89606480(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
